// extracted by mini-css-extract-plugin
export default {"megaMenu":"menu_megaMenu__-zwXa","megaMenuOpen":"menu_megaMenuOpen__sfzvN","megaMenuItem":"menu_megaMenuItem__AtMws","megaMenuSection":"menu_megaMenuSection__DoUTc"};